/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { AppState } from '@app/core/types';
import { createFeatureSelector, createSelector as ngrxCreateSelector } from '@ngrx/store';
import { currentClusterSelector } from './app.selectors';

export const metricDefs = createFeatureSelector<AppState['metricDefs']>('metricDefs');
export const currentClusterMetricDefs = ngrxCreateSelector(
  currentClusterSelector,
  metricDefs,
  (currentClusterId, metricDefs) =>
    !currentClusterId || !metricDefs[currentClusterId] ? undefined : Object.values(metricDefs[currentClusterId] ?? {}),
);
export const currentClusterMetricDefsMap = ngrxCreateSelector(
  currentClusterSelector,
  metricDefs,
  (currentClusterId, metricDefs) =>
    !currentClusterId || !metricDefs[currentClusterId] ? undefined : (metricDefs[currentClusterId] ?? {}),
);
